import { IconBuilder } from "/app/src/components/icons/IconBuilder";
import Apps from "./apps";
import ClickableNavItem from "./clickableNavItem";
import ClickableAvatar from "./avatar";
import { useStatusContext } from "/app/src/contexts/hooks/useStatusContext";
import { useAuthState } from "/app/src/contexts/authentication";
import { Divider } from "@heroui/react";
import useSetting from "/app/src/components/settings/setting";

/**
 *
 * @returns Sidebar
 */
export default function Sidebar() {
  const { message, loading } = useStatusContext();
  const { isAuthenticated, user } = useAuthState();

  const { settingValue: pinnedExplorer } = useSetting({
    name: "explorerNavigation",
    userId: user?.id,
  });

  if (loading) {
    return null;
  } else {
    return (
      <div>
        {isAuthenticated &&
          !["invalid", "locked", "restarting"].includes(message) && (
            <nav className="fixed inset-y-0 left-0 bg-white w-20 py-4 flex flex-col">
              <div className="flex justify-center mb-6">
                <IconBuilder icon="NavigationLogo" color="#2491FF" />
              </div>
              {/* Links */}
              <div className="flex flex-col overflow-y-auto">
                <ClickableNavItem icon="DashboardIcon" navTo="/dashboard" />
                <Apps />
                <ClickableNavItem icon="ExplorerIcon" navTo="/explorer" />
                <ClickableNavItem icon="ReportsIcon" navTo="/reports" />
                <ClickableNavItem icon="WorkflowsIcon" navTo="/workflows" />
                <ClickableNavItem icon="AppsIcon" navTo="/apps" />
                <ClickableNavItem icon="UsersIcon" navTo="/users" />
                {pinnedExplorer &&
                  pinnedExplorer
                    .split(",")
                    .map((it) => it.trim())
                    .filter((it) => it && it.length > 0)
                    .map((item) => {
                      // map known explorer keys to specific icons (matches IconBuilder available icons)
                      const iconMap: Record<string, string> = {
                        // order options
                        batches: "BatchIcon",
                        orders: "OrderIcon",
                        order_lines: "OrderLineIcon",
                        transactions: "TransactionIcon",
                        // material options
                        materials: "MaterialIcon",
                        material_properties: "MaterialPropertyIcon",
                        // location options
                        bins: "BinIcon",
                        locations: "LocationIcon",
                        warehouses: "WarehouseIcon",
                        zones: "ZoneIcon",
                        // power pick options
                        cost_centers: "CostCenterIcon",
                        parameter_values: "ParameterValueIcon",
                      };

                      const icon = iconMap[item] || "ExplorerIcon";

                      return (
                        <ClickableNavItem
                          key={item}
                          icon={icon}
                          navTo={`/explorer/${item}`}
                        />
                      );
                    })}
              </div>
              {/* These navigation items will be pushed to the bottom of the container */}
              <div className="mt-auto flex flex-col">
                <a
                  href="https://itempath.com/contact-support"
                  target="_blank"
                  rel="noopener noreferrer"
                  // Using target="_blank" without rel="noreferrer" (which implies rel="noopener") is a security risk in older browsers:
                  //see https://mathiasbynens.github.io/rel-noopener/#recommendations
                >
                  <ClickableNavItem icon="HelpIcon" />
                </a>
                <ClickableNavItem icon="SettingsIcon" navTo="/settings" />
                <Divider className="mb-2" />
                <ClickableAvatar />
              </div>
            </nav>
          )}
      </div>
    );
  }
}
